import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { skills } from '../data/content';
export function Skills() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="skills-title" data-id="element-165" data-mp="pnpey9g5imit">
      <div className="mx-auto max-w-6xl px-5" data-id="element-166" data-mp="13ihz5l6zkqvq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-167" data-mp="yqqf7tic5jek">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-168" data-mp="yp5o6dv8cilg">
            Lo que vas a dominar
          </span>
          <h2 id="skills-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-169" data-mp="18gjqsuih9yit">
            Cuatro habilidades que separan a una principiante de una tejedora experta
          </h2>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2" data-id="element-170" data-mp="1hi9lc97npdkt">
          {skills.map((skill, index) => <motion.article key={skill.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.07
        }} className="rounded-3xl border border-wool bg-cream p-7" data-id="element-171" data-mp="3o8h55p4h0pvp" data-mpi={index}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sage/25 text-sage" data-id="element-172" data-mp="qhl25jgo7i6n">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-173" data-mp="v89vz5ftor8y" />
              </span>
              <h3 className="mt-5 font-display text-xl font-black text-ink" data-id="element-174" data-mp="z9vd52ze3roy">{skill.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-175" data-mp="148g74ko1tf4y">{skill.description}</p>
            </motion.article>)}
        </div>

        <div className="mt-14 overflow-hidden rounded-[2rem]" data-id="element-176" data-mp="19947hwy638bu">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/80d0d825-d2c3-4350-8a9b-e320a7c1bc94.jpg" alt="Colección de seis amigurumis en colores pastel: gato, oso, conejo, elefante, zorro y ballena" className="h-full w-full object-cover" data-id="element-177" data-mp="1e6m9f3dronac" />
        </div>
      </div>
    </section>;
}